import { createAction, props } from '@ngrx/store';
import { WorkflowOrigin, WorkflowStep, WorkflowStepType, WorkflowType } from '@warema/shared/models';

export const InitializeWorkflow = createAction(
    '[Workflow] WorkflowInitialized',
    props<{
        steps: Array<WorkflowStep>;
        stepType: WorkflowStepType | null;
        workflowOrigin: WorkflowOrigin;
        workflowType: WorkflowType;
    }>(),
);

export const SetStep = createAction('[Workflow] Set step', props<{ newStep: WorkflowStep }>());

export const SetStepValidity = createAction(
    '[Workflow] Set step validity',
    props<{ isValid: boolean; stepType: WorkflowStepType }>(),
);
